module.exports = __webpack_public_path__ + "img/scene_night_light_dw_big@2x.f544a239.png";